module.exports = __webpack_public_path__ + "static/img/togehanebae.8b39bd4.jpg";